module.exports = __webpack_public_path__ + "img/user.67f9ce82.svg";